import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {EntityMegaHeaderModuleTerms} from "./entity-mega-header-module.terms";

export class EntityMegaHeaderModuleConfig extends BaseConfig {

  static injectables = [EntityMegaHeaderModuleTerms];

  constructor(terms: EntityMegaHeaderModuleTerms) {
    super('entityMegaHeaderModule', null, terms);
  }
}
